export class Route {
    /**
     * @param _options
     */
    constructor(_options) {
        this._options = _options;
    }
    /**
     * @return {RouteOptions}
     */
    get options() {
        return this._options;
    }
    /**
     * @return {string}
     */
    get name() {
        return this.options.name;
    }
    /**
     * @return {string}
     */
    get path() {
        return this.options.path;
    }
    /**
     * @return {Route[]|Array}
     */
    get children() {
        return this.options.children || [];
    }
    /**
     * @return {Route[]|Array}
     */
    get callback() {
        return this.options.callback;
    }
    /**
     * @return {Route[]|Array}
     */
    get middleware() {
        return this.options.middleware || (() => Promise.resolve());
    }
}
